import {useCallback} from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_ORDERS_ORDER_API,
    GET_ORDERS_OVERVIEW_OPTIONS_API,
    GET_ORDERS_REISSUING_DIALOG_API,
    POST_ORDERS_OVERVIEW_API,
    POST_ORDERS_OVERVIEW_ADVANCE_API,
    POST_ORDERS_REISSUING_API,
    PUT_ORDERS_REISSUING_API,
    PUT_ORDERS_DELETE_API,
    PUT_ORDERS_REINIT_API
} from '@Apis/apiPath';

const useOrderApi = () => {
    const Axios = useAxios();

    const getOrderApi = useCallback(async (orderID) => {
            return await Axios.get(GET_ORDERS_ORDER_API(orderID));
        },
        // eslint-disable-next-line
        []);

    const getOrderOverviewOptionsApi = useCallback(async () => {
        return await Axios.get(GET_ORDERS_OVERVIEW_OPTIONS_API)
    },
        // eslint-disable-next-line
        []);

    const getOrderReissuingDialogApi = useCallback(async (orderID) => {
        return await Axios.get(GET_ORDERS_REISSUING_DIALOG_API(orderID));
    },
        // eslint-disable-next-line
        []);

    const postOrdersOverviewApi = useCallback(async (params) => {
        return await Axios.post(POST_ORDERS_OVERVIEW_API, params);
    },
        // eslint-disable-next-line
        []);

    const postOrdersOverviewAdvanceApi = useCallback(async (params) => {
        return await Axios.post(POST_ORDERS_OVERVIEW_ADVANCE_API, params);
    },
        // eslint-disable-next-line
        []);

    const postOrdersReissuingApi = useCallback(async (params = {}) => {
        return await Axios.post(POST_ORDERS_REISSUING_API(params?.orderID), params);
    },
        // eslint-disable-next-line
        []);

    const putOrdersReissuingApi = useCallback(async (params) => {
        return await Axios.put(PUT_ORDERS_REISSUING_API(params?.orderID), params);
    },
        // eslint-disable-next-line
        []);

    const putOrdersDeleteApi = useCallback(async (params) => {
        return await Axios.put(PUT_ORDERS_DELETE_API(params?.orderID), params);
    },
        // eslint-disable-next-line
        []);

    const putOrdersReinitApi = useCallback(async (params) => {
        return await Axios.put(PUT_ORDERS_REINIT_API(params?.orderID), params);
    },
        // eslint-disable-next-line
        []);

    return {
        getOrderApi,
        getOrderOverviewOptionsApi,
        getOrderReissuingDialogApi,
        postOrdersOverviewApi,
        postOrdersOverviewAdvanceApi,
        postOrdersReissuingApi,
        putOrdersReissuingApi,
        putOrdersDeleteApi,
        putOrdersReinitApi,
    };
};

export default useOrderApi;
